import * as t from "io-ts";

const nullable = <T extends t.Type<any, any, any>>(codec: T) =>
  t.union([t.null, codec]);

export default nullable;
